const DiamondShapes = [
    { id: 1, img: "radient", value: "Radiant" },
    { id: 2, img: "cushion", value: "Cushion" },
    { id: 3, img: "oval", value: "Oval" },
    { id: 4, img: "heart", value: "Heart" },
    { id: 5, img: "pear", value: "Pear" },
    { id: 6, img: "emerald", value: "Emerald" },
    { id: 7, img: "round", value: "Round" },
    { id: 8, img: "marquise", value: "Marquise" },
    { id: 9, img: "hexagon", value: "Hexagon" },
    { id: 10, img: "triangular-brilliant", value: "Triangular Brilliant" },
    { id: 11, img: "octagon", value: "Octagon" },
    { id: 12, img: "princess", value: "Princess" },
    { id: 13, img: "trilliant", value: "Trilliant" },
    { id: 14, img: "kite", value: "Kite" },
    { id: 15, img: "shield", value: "Shield" },
  ];

 export function getScaleForImage(shape, ratio) {
    if (!shape || !ratio) return 1.0;
  
    const scaleMap = {
      Cushion: [
        { upto: 1.09, scale: 1 },
        { upto: 1.19, scale: 1.05 },
        { upto: 1.29, scale: 1.1 },
        { upto: Infinity, scale: 1.15 },
      ],
      Radiant: [
        { upto: 1.09, scale: 1 },
        { upto: 1.19, scale: 1.05 },
        { upto: 1.29, scale: 1.1 },
        { upto: Infinity, scale: 1.15 },
      ],
      Oval: [
        { upto: 1.29, scale: 0.75 },
        { upto: 1.39, scale: 0.83 },
        { upto: 1.44, scale: 0.91 },
        { upto: Infinity, scale: 1 },
      ],
      Heart: [
        { upto: 0.99, scale: 1 },
        { upto: 1.04, scale: 1.05 },
        { upto: Infinity, scale: 1.1 },
      ],
 
      Pear: [
        { upto: 1.39, scale: 1 },
        { upto: 1.49, scale: 1.05 },
        { upto: 1.59, scale: 1.1 },
        { upto: Infinity, scale: 1.15 },
      ],
      Emerald: [
        { upto: 1.19, scale: 0.65 },
        { upto: 1.29, scale: 0.78 },
        { upto: 1.39, scale: 0.91 },
        { upto: Infinity, scale: 1 },
      ],
    };
  
    const shapeData = scaleMap[shape];
    if (!shapeData) return 1.0;
    const ratioData = shapeData.find((data) => Number(ratio) <= data.upto);
    return ratioData ? ratioData.scale : 1.0;
  }
  
  export const getShapeForImage = (shape) => {
    const item = DiamondShapes.find((item) => shape === item.value);
    return item ? item.img : "";
  };